// Language helpers for AI translation (ADR-035).
//
// Codes are BCP-47 primary tags ('es', 'pt', 'zh', 'ht' …) — the same values the
// backend stores on contact.language / user.language. The curated list is what
// the pickers offer; anything else the model detects still gets a name through
// Intl.DisplayNames. Mirrored in the Chrome extension (src/utils/languages.ts).

import session from './session';

export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGES = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Spanish' },
    { code: 'pt', label: 'Portuguese' },
    { code: 'fr', label: 'French' },
    { code: 'ht', label: 'Haitian Creole' },
    { code: 'vi', label: 'Vietnamese' },
    { code: 'zh', label: 'Chinese' },
    { code: 'tl', label: 'Tagalog' },
    { code: 'ar', label: 'Arabic' },
    { code: 'ru', label: 'Russian' },
    { code: 'uk', label: 'Ukrainian' },
    { code: 'ko', label: 'Korean' },
    { code: 'hi', label: 'Hindi' },
    { code: 'pa', label: 'Punjabi' },
    { code: 'ne', label: 'Nepali' },
    { code: 'my', label: 'Burmese' },
    { code: 'so', label: 'Somali' },
    { code: 'am', label: 'Amharic' },
    { code: 'sw', label: 'Swahili' },
    { code: 'de', label: 'German' },
    { code: 'it', label: 'Italian' },
    { code: 'pl', label: 'Polish' },
];

const LANG_RE = /^[a-z]{2,3}(-[a-z]{2})?$/;
const CURATED = LANGUAGES.reduce((a, l) => { a[l.code] = l.label; return a; }, {});

let displayNames = null;
try {
    displayNames = new Intl.DisplayNames(['en'], { type: 'language' });
} catch (e) {
    displayNames = null;
}

/** Lower-cased, validated primary tag or null. */
export function normalizeLang(code) {
    if (typeof code !== 'string') return null;
    const c = code.trim().toLowerCase();
    return LANG_RE.test(c) ? c : null;
}

/** 'es' → 'Spanish'. Falls back to Intl, then the code itself. */
export function langName(code) {
    const c = normalizeLang(code);
    if (!c) return '';
    if (CURATED[c]) return CURATED[c];
    try {
        const n = displayNames && displayNames.of(c);
        return n && n !== c ? n : c;
    } catch (e) {
        return c;
    }
}

/** The logged-in user's language (session.userData.language, from the login payload). */
export function getUserLanguage() {
    try {
        const u = session.get('userData') || {};
        return normalizeLang(u.language) || DEFAULT_LANGUAGE;
    } catch (e) {
        return DEFAULT_LANGUAGE;
    }
}

/** antd Select options for the curated list (a code outside it is appended so it stays selectable). */
export function languageOptions(current) {
    const opts = LANGUAGES.map((l) => ({ value: l.code, label: l.label }));
    const c = normalizeLang(current);
    if (c && !CURATED[c]) opts.push({ value: c, label: langName(c) });
    return opts;
}
